import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormulaValidationResult} from '../../Services/template.service';

@Component({
  selector: 'np-formula-editor',
  templateUrl: './formula-editor.component.html',
  standalone: false
})
export class FormulaEditorComponent {
  @Input() placeholderItems: any[] = [];
  @Input() placeholderDisplayExpr: (item: any) => string;
  @Input() placeholderName: (item: any) => string;
  @Input() placeholderLabel = 'Excel-Spalte';
  @Input() placeholderSelectText = 'Spalte wählen';
  @Input() tooltipText = 'FormelModusTooltip';
  @Input() disabled = false;
  @Input() formula = '';
  @Input() preview: FormulaValidationResult;

  @Output() formulaChange = new EventEmitter<string>();

  selectedPlaceholderItem: any;

  insertPlaceholder(): void {
    const name = this.selectedPlaceholderItem ? this.placeholderName(this.selectedPlaceholderItem) : '';
    if (!name) return;
    this.updateFormula((this.formula ?? '') + `[${name}]`);
  }

  onFormulaValueChanged(value: string): void {
    if (value === this.formula) return;
    this.updateFormula(value);
  }

  private updateFormula(value: string): void {
    this.formula = value;
    this.formulaChange.emit(value);
  }
}
